__webpack_require__.p = "https://widget.simpego.ch/";